<script>
  import { computed, onBeforeUnmount, onMounted, ref } from '@nuxtjs/composition-api'

  // Keep in sync with the `.collapsed` max-height below (300px).
  const COLLAPSED_HEIGHT = 300

  export default {
    props: {
      showCollapsed: {
        type: Boolean,
        default: true
      }
    },
    setup (props) {
      const collapsed = ref(true)
      const content = ref(null)

      // The clamp was a FIXED height, so content SHORTER than the clamp was
      // padded out to 300px: a product without an EX-description rendered an
      // empty white block with a "+ Meer tonen" button that collapsed it to
      // nothing, jumping the rest of the page up (EXAMS-138 QA, mobiel).
      // Starts true so the server-rendered markup clamps exactly as before;
      // once mounted we measure and drop the clamp when nothing is hidden.
      const overflows = ref(true)

      const measure = () => {
        overflows.value = !!content.value && content.value.scrollHeight > COLLAPSED_HEIGHT
      }

      onMounted(() => {
        measure()
        window.addEventListener('resize', measure)
      })

      onBeforeUnmount(() => {
        window.removeEventListener('resize', measure)
      })

      const isCollapsible = computed(() => props.showCollapsed && overflows.value)

      const expand = () => {
        collapsed.value = false
      }

      return {
        collapsed,
        content,
        isCollapsible,
        expand
      }
    }
  }
</script>

<template>
  <div class="relative">
    <div
      ref="content"
      :class="{
        'collapsed': collapsed && isCollapsible,
      }"
    >
      <slot></slot>
    </div>
    <div
      v-if="isCollapsible && collapsed"
      class="absolute bottom-0 left-0 right-0 flex items-end pt-4 bg-white"
    >
      <button
        type="button"
        class="flex items-center space-x-2 font-bold text-blue-500 transition-all hover:text-blue-600"
        @click="expand"
      >
        <span>+ Meer tonen</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
  .show-more {
    height: 7.1875rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 51.04%);;
  }

  .collapsed {
     @apply overflow-hidden;
     /* max-height, NOT height: a fixed height padded short content out to the
        full 300px (see setup()).
        In px, NOT rem, to mirror COLLAPSED_HEIGHT exactly: setup() compares it
        against `scrollHeight`, which is always CSS pixels, so a rem clamp drifts
        away from the measurement as soon as the root font-size is not 16px. */
     max-height: 300px;
   }
</style>
